<template>
<v-container >

		<v-layout column wrap align-center><v-flex xs12 sm6>
			<v-btn small @click="prevCalendar()">&lt;&lt;</v-btn>
			{{ yyyymm }}
			<v-btn small v-on:click="nextCalendar()">&gt;&gt;</v-btn>
		</v-flex></v-layout>
		<v-layout column wrap align-center><v-flex xs12 sm6>
			<v-radio-group v-model="place" row mandatory>
				<v-radio label="社内" value="0"></v-radio>
				<v-radio label="自宅" value="1"></v-radio>
				<v-btn small @click="registTimecard('begin')">出勤</v-btn>
				<v-btn small v-on:click="registTimecard('end')">退勤</v-btn>
			</v-radio-group>
		</v-flex></v-layout>
		<v-alert v-model="updateSuccess" dismissible type="success">
		{{ registMsg }}しました
		</v-alert>
		<v-data-table light :items="timecards" item-key="day" :headers="headers" :rows-per-page-items="maxItems">
			<template v-slot:items="props">
			<td>{{ props.item.dayTitle }}</td>
			<td>{{ props.item.in_time }}</td>
			<td>{{ props.item.out_time }}</td>
			<td>{{ props.item.in_time ? (props.item.place == 0 ? "社内" : "自宅") : "" }}</td>
			</template>
		</v-data-table>
</v-container>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
import axios from 'axios';
// locale="japan" event-start="startDate" event-end="startDate" event-name="name"
  export default {
    computed: {
    },
    data: function() {
		return {
			timecards: [],
			currentDate: new Date(),
			maxItems: [-1],
			yyyymm: "",
			headers: [
				{ text: '日付', value: 'dayTitle', sortable: false },
				{ text: '出勤', value: 'in_time' , sortable: false},
				{ text: '退勤', value: 'out_time' , sortable: false},
				{ text: '勤務場所', value: 'place' , sortable: false},
			],
			updateSuccess: false,
			registMsg: "",
			place: "0",
        };
    },
    mounted: function() {
	},
	watch: {
	},
	methods: {
		initDisp: function() {
	    	var now = new Date();
	    	this.currentDate = now;
	   		this.yyyymm = this.currentDate.getFullYear() + "-" + (this.currentDate.getMonth() + 1);
			this.getTimecards();
		},
		prevCalendar: function() {
			this.updateSuccess = false;
			this.currentDate.setMonth(this.currentDate.getMonth() - 1);
	   		this.yyyymm = this.currentDate.getFullYear() + "-" + (this.currentDate.getMonth() + 1);
			this.getTimecards();
		},
		nextCalendar: function() {
			this.updateSuccess = false;
			this.currentDate.setMonth(this.currentDate.getMonth() + 1);
	   		this.yyyymm = this.currentDate.getFullYear() + "-" + (this.currentDate.getMonth() + 1);
			this.getTimecards();
		},
		registTimecard: function(mode) {
			var params = new URLSearchParams();
			params.append("type", mode);
			params.append("place", this.place);
			axios.post("api_timecard_update", params).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
					this.registMsg = mode == "begin" ? appResp.data.in_time.substring(11, 16) + "に" + "出勤" : appResp.data.out_time.substring(11, 16) + "に" + "退勤";
					this.updateSuccess = true;
					this.getTimecards();
				} else if (appResp.status == "-7") {
					this.$emit('needLogin');
				}
			});
		},
		formatTimecardTime: function(tm) {
			var hhmm = tm.substring(11, 16);
			var hh = parseInt(hhmm.split(":")[0]) + 9;
			return (hh >= 24 ? hh - 24 : hh) + hhmm.substring(2);
		},
		getTimecards: function() {
			axios.get("api_timecard", {
				params: {
					baseDate: this.yyyymm + "-1",
				}
			}).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
			        this.timecards = appResp.data;
			        this.timecards.forEach(function(tm) {
			        	if (tm.in_time) {
			        		tm.in_time = this.formatTimecardTime(tm.in_time);
			        	}
			        	if (tm.out_time) {
			        		tm.out_time = this.formatTimecardTime(tm.out_time);
			        	}
			        }, this);
				} else if (appResp.status == "-7") {
					this.$emit('needLogin');
				}
			});
		},
	},
  }
</script>

<style scoped>
</style>

